import React, { createContext, useContext, useState } from "react";

const GIDContext = createContext();

export const GIDProvider = ({ children }) => {
    const [gid, setGid] = useState(null);

    return (
        <GIDContext.Provider value={{ gid, setGid }}>
            {children}
        </GIDContext.Provider>
    );
};

export const useGID = () => useContext(GIDContext);
